// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.filter-header {\n    margin-left: calc(0.5rem + 2px);\n    padding-bottom: 0;\n    font-size: 12px;\n    font-weight: bold;\n}\n.custom-radio > .custom-control-label > span {\n    vertical-align: text-top;\n}\n", ""]);
// Exports
module.exports = exports;
